module.exports = __webpack_public_path__ + "media/52.a4ea1f26.mp3";